module.exports = __webpack_public_path__ + "img/small.b0fccc28.jpg";